const initialState = {
  resultsGatewaysList: [],
  resultsPartnersList: [],
  initializedProfileToken: "",
  resultsPaymentProfileList: [],
  getSelectProfileDetails: {},
  paymentProfileCreationResponse: {},
  paymentProfileUpdateResponse: {},
  partnerDetails: {},
  loading: false,
  error: null,
  tokenError: null,
  productMapProfile: "",
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_PARTNERS_RESPONSE":
      newState.resultsPartnersList = action.value;
      break;
    case "LIST_GATEWAYS_RESPONSE":
      newState.resultsGatewaysList = action.value;
      break;
    case "SET_PROFILE_CREATION_IFRAME_TOKEN":
      return {
        ...newState,
        loading: false,
        initializedProfileToken: action.value,
        tokenError: action.value.responseStatus === "error" ? action.value : null
      }
    case "LIST_PAYMENT_PROFILE_RESPONSE":
      newState.resultsPaymentProfileList = action.value;
      break;
    case "PRODUCT_MAP_PROFILE":
      newState.productMapProfile = action.profile;
      break;
    case "GET_PAYMENT_PROFILE_DETAILS":
      newState.getSelectProfileDetails = action.value;
      break;
    case "GET_PAYMENT_PROFILE_CREATED":
      newState.paymentProfileCreationResponse = action.value;
      break;
    case "PAYMENT_PROFILE_UPDATE":
      newState.paymentProfileUpdateResponse = action.value;
      break;
    case "GET_CREATED_PARTNER_DETAILS":
      newState.partnerDetails = action.value;
      break;
    case "RESET_PAYMENT_LOADING_ERROR":
      return {
        ...newState,
        loading: false,
        error: null
      }
    case "RESET_PROFILE_TOKEN_ERROR":
      return {
        ...newState,
        tokenError: null
      }
    case "PAYMENT_API_ERROR":
      return {
        ...newState,
        error: true
      }
    case "RESET_PAYMENT_PROFILE_RESPONSES":
      newState.resultsGatewaysList = [];
      newState.resultsPartnersList = [];
      newState.initializedProfileToken = "";
      newState.resultsPaymentProfileList = [];
      newState.getSelectProfileDetails = {};
      newState.paymentProfileCreationResponse = {};
      newState.paymentProfileUpdateResponse = {};
      newState.partnerDetails = [];
      newState.loading = false;
      newState.error = null;
      newState.productMapProfile = "";
      newState.tokenError = null;
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;